import { Routes } from '@angular/router';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { authGuard } from './auth/guards/auth.guard';
import { roleGuard } from './auth/guards/role.guard';
import { KEYCLOAK_GROUPS } from '@ics-referral-hub/shared-types';

export const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    canActivate: [authGuard],
  },
  {
    path: 'hospitals',
    loadChildren: () =>
      import('./features/hospitals/hospitals-routing.module').then(
        (m) => m.hospitalRoutes,
      ),
    canActivate: [authGuard, roleGuard],
    data: {
      groups: [KEYCLOAK_GROUPS.INTERNAL_ADMIN, KEYCLOAK_GROUPS.SUPER_ADMIN],
    },
  },
  {
    path: 'hospital-users',
    loadChildren: () =>
      import('./features/hospital-users/hospital-users.routes').then(
        (m) => m.HOSPITAL_USERS_ROUTES,
      ),
    canActivate: [authGuard, roleGuard],
    data: {
      permissions: ['canManageUsers'],
    },
  },
  {
    path: 'programs',
    loadChildren: () =>
      import('./features/programs/programs.routes').then(
        (m) => m.PROGRAMS_ROUTES,
      ),
    canActivate: [authGuard, roleGuard],
    data: {
      permissions: ['canManagePrograms'],
    },
  },
  {
    path: 'referrals',
    loadChildren: () =>
      import('./features/referrals/referrals.routes').then(
        (m) => m.REFERRALS_ROUTES,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'internal-users',
    loadChildren: () =>
      import('./features/internal-users/internal-users.routes').then(
        (m) => m.INTERNAL_USERS_ROUTES,
      ),
    canActivate: [authGuard, roleGuard],
    data: {
      groups: [KEYCLOAK_GROUPS.SUPER_ADMIN, KEYCLOAK_GROUPS.INTERNAL_ADMIN],
    },
  },
  {
    path: 'admin', // Admin area for system-wide administration
    loadChildren: () =>
      import('./features/admin/admin.routes').then((m) => m.ADMIN_ROUTES),
    canActivate: [authGuard, roleGuard],
    data: {
      groups: [KEYCLOAK_GROUPS.SUPER_ADMIN, KEYCLOAK_GROUPS.INTERNAL_ADMIN],
    },
  },
  {
    path: 'audit-logs',
    loadComponent: () =>
      import('./features/audit-logs/audit-logs.component').then(
        (m) => m.AuditLogsComponent,
      ),
    canActivate: [authGuard, roleGuard],
    data: {
      groups: [KEYCLOAK_GROUPS.SUPER_ADMIN],
    },
  },
  {
    path: 'program-definitions',
    loadComponent: () =>
      import(
        './features/program-definitions/program-definitions-editor.component'
      ).then((m) => m.ProgramDefinitionsEditorComponent),
    canActivate: [authGuard, roleGuard],
    data: {
      groups: [KEYCLOAK_GROUPS.SUPER_ADMIN],
    },
  },
  {
    path: 'setup-password',
    loadComponent: () =>
      import('./auth/components/invitation/invitation-flow.component').then(
        (m) => m.InvitationFlowComponent,
      ),
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./features/settings/settings.routes').then(
        (m) => m.SETTINGS_ROUTES,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'hospital-inactive',
    loadComponent: () =>
      import('./features/hospital-inactive/hospital-inactive.component').then(
        (m) => m.HospitalInactiveComponent,
      ),
  },
  {
    path: 'version',
    loadComponent: () =>
      import('./features/version/version.component').then(
        (m) => m.VersionComponent,
      ),
  },
  {
    path: 'mbc-analytics',
    loadChildren: () =>
      import('./features/mbc-analytics/mbc-analytics.routes').then(
        (m) => m.MBC_ANALYTICS_ROUTES,
      ),
  },
  {
    path: 'ohah-portal',
    title: 'Ontario Health at Home',
    loadChildren: () =>
      import('./features/ohah-portal/ohah-portal.routes').then(
        (m) => m.OHAH_PORTAL_ROUTES,
      ),
  },
  {
    path: '**',
    redirectTo: '',
    canActivate: [authGuard],
  },
];
